import {parseURLQuery} from 'app/utils/location/parseURLQuery';

export function getUrlParameters() {
    const hash = window.location.hash ?? '';
    const urlFragment = getUrlFragment(hash);

    return {
        ...parseURLQuery(window.location.search),
        ...parseURLQuery(hash.split('?')[1]),
        ...(urlFragment ? {urlFragment} : {}),
    };
}

function getUrlFragment(hash: string): string | undefined {
    if (!hash.startsWith('#')) {
        return;
    }

    const parsedLocationHash = hash.substring(1);
    if (!parsedLocationHash) {
        return;
    }

    return parsedLocationHash;
}
